import { render, staticRenderFns } from "./ShadowSetting.vue?vue&type=template&id=fb6f03f4&scoped=true"
import script from "./ShadowSetting.vue?vue&type=script&lang=js"
export * from "./ShadowSetting.vue?vue&type=script&lang=js"
import style0 from "./ShadowSetting.vue?vue&type=style&index=0&id=fb6f03f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb6f03f4",
  null
  
)

export default component.exports